exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-label[data-v-a2cf935e]{width:30%}", ""]);

// exports
